import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest, startWith } from 'rxjs';

import { BreadcrumbService } from '@shared/breadcrumb/breadcrumb.service';

@Injectable({ providedIn: 'root' })
export class PageTitleService {
  private readonly title = inject(Title);
  private readonly breadcrumbService = inject(BreadcrumbService);
  private readonly translate = inject(TranslateService);

  private readonly SEPARATOR = ' • ';
  private readonly APP_NAME = 'Galia';

  initialize(): void {
    combineLatest([
      this.breadcrumbService.getBreadcrumbs(),
      this.translate.onLangChange.pipe(startWith(null))
    ]).subscribe(([items]) => {
      if (items.length === 0) {
        const homeLabel = this.translate.instant('topbar.breadcrumb.home');
        this.title.setTitle(`${homeLabel}${this.SEPARATOR}${this.APP_NAME}`);
        return;
      }

      const lastItem = items[items.length - 1];
      if (lastItem.label) {
        this.title.setTitle(`${lastItem.label}${this.SEPARATOR}${this.APP_NAME}`);
      } else {
        this.title.setTitle(this.APP_NAME);
      }
    });
  }
}
